import React from 'react'
import { Container, Accordion, Image } from 'react-bootstrap';

import InSiteIntelligenceIcon from '../../assets/img/experience/insite_intelligence.svg'
import CurrentIQIcon from '../../assets/img/experience/current_iq.svg'
import ConstructionIcon from '../../assets/img/experience/construction.svg'
import FiableIcon from '../../assets/img/experience/fiable.svg'
import DXCIcon from '../../assets/img/experience/dxc.svg'
import SPDIcon from '../../assets/img/experience/spd.svg'
import WaterPoloIcon from '../../assets/img/experience/water_polo.svg'

export const InSiteIntelligenceSummary = {
    company: 'InSite Intelligence',
    title: 'Applied AI Project Manager',
    logo: InSiteIntelligenceIcon,
    dateStart: '1/1/2026',
    dateEnd: 'Present',
    summary: (
        <div>
            <ul>
                <li>Manage a team of four engineers building a cutting-edge, AI-integrated building management platform.</li>
                <li>Set technical direction and delivery priorities for the team's applied AI initiatives.</li>
                <li>Coordinate across engineering, product, and stakeholders to align AI capabilities with real building operations needs.</li>
            </ul>
        </div>
    )
}

export const CurrentIQSummary = {
    company: 'Current iQ',
    title: 'Solutions Engineer',
    logo: CurrentIQIcon,
    dateStart: '1/1/2025',
    dateEnd: '12/31/2025',
    summary: (
        <div>
            <ul>
                <li>Managed a small development team to build a live, reactive turbine data analytics platform.</li>
                <li>Coordinated the installation of edge computers at hospital, hotel, and campus turbine systems.</li>
                <li>Delegated key tasks to responsible parties and upheld a strict project schedule and timeline.</li>
            </ul>
        </div>
    )
}

export const ConstructionSummary = {
    company: 'Residential Construction',
    title: 'Owners Representative',
    logo: ConstructionIcon,
    dateStart: '6/1/2024',
    dateEnd: 'Present',
    summary: (
        <div>
            <ul>
                <li>Oversaw designing, permitting, pre-construction, construction, and sale of multiple residential buildings.</li>
                <li>Managed sub-contractors for sitework, foundations, framing, HVAC, plumbing, drywall, painting, electrical, and more. </li>
                <li>Learned modern construction requirements, processes, regulations, and procedures.</li>
            </ul>
        </div>
    )
}

export const FiableSummary = {
    company: 'Fiable Solutions',
    title: 'Chief Technology Officer',
    logo: FiableIcon,
    dateStart: '1/15/2024',
    dateEnd: '12/15/2024',
    summary: (
        <div>
            <ul>
                <li>Built and managed the development of a modern and responsive React Javascript web application.</li>
                <li>Designed and implemented a serverless backend using Google Firebase and Cloud Storage.</li>
                <li>Worked with modern AI models and frameworks to build integrated user tools and services.</li>
            </ul>
        </div>
    )
}

export const DXCSummary = {
    company: 'DXC Technology',
    title: 'Application Developer',
    logo: DXCIcon,
    dateStart: '12/1/2022',
    dateEnd: '12/15/2023',
    summary: (
        <div>
            <ul>
                <li>Maintained and optimized a General Dynamics Java application for submarine manufacturers.</li>
                <li>Designed end-to-end features for shipyard workers to automate and improve their workflow.</li>
                <li>Collaborated with a team of developers on multiple projects using Github, Jira, and other team coordination applications.</li>
            </ul>
        </div>
    )
}

const SPDSummary = {
    company: 'Sigma Phi Delta (Collegiate)',
    title: 'Vice President',
    logo: SPDIcon,
    dateStart: '11/15/2020',
    dateEnd: '11/15/2021',
    summary: (
        <div>
            <ul>
                <li>Managed all internal fraternity affairs, including recruitment and all professional/brotherhood events.</li>
                <li>Assisted with the management of the annual budget and organized two large professional trips.</li>
                <li>Coordinated with the President in managing all internal elected and appointed positions.</li>
            </ul>
        </div>
    )
}

const WaterPoloSummary = {
    company: 'UMD Club Water Polo (Collegiate)',
    title: 'Club President',
    logo: WaterPoloIcon,
    dateStart: '12/15/2018',
    dateEnd: '12/15/2020',
    summary: (
        <div>
            <ul>
                <li>Organized tournaments, interfaced with UMD sports office, managed finances, and coached the team.</li>
                <li>Led new player recruitment, as well as ensuring existing member retention.</li>
                <li>Managed the team’s CWPA League participation, requiring regional trip coordination.</li>
            </ul>
        </div>
    )
}

const Experience = () => {
    return (
        <>
            <section className='bg-primary py-4 mb-1'>
                <Container>
                    <h1 className='text-uppercase text-center text-secondary'>Work Experience</h1>
                    <hr className='star-dark mb-0' />
                    <h4 className='text-center text-secondary'>Survey My Professional Efforts</h4>
                </Container>
            </section>
            <Container>
                <Accordion defaultActiveKey='0' className='mb-1'>
                    <ExperienceAccordionItem data={InSiteIntelligenceSummary} eventKey='0' />
                    <ExperienceAccordionItem data={CurrentIQSummary} eventKey='1' />
                    <ExperienceAccordionItem data={ConstructionSummary} eventKey='2' />
                    <ExperienceAccordionItem data={FiableSummary} eventKey='3' />
                    <ExperienceAccordionItem data={DXCSummary} eventKey='4' />
                    <ExperienceAccordionItem data={SPDSummary} eventKey='5' />
                    <ExperienceAccordionItem data={WaterPoloSummary} eventKey='6' />
                </Accordion>
            </Container>
        </>
    )
}

const ExperienceAccordionItem = ({data, eventKey}) => {
    return (
        <Accordion.Item eventKey={eventKey}>
            <Accordion.Header>
                <div className='d-flex align-items-center gap-3'>
                    <Image src={data.logo} alt='' width={44} height={44} rounded />
                    <span className='fw-bold text-secondary'>{data.company}</span>
                </div>
            </Accordion.Header>
            <Accordion.Body>
                <i>{data.title}</i>
                {data.summary}
                <i>{data.dateStart}-{data.dateEnd}</i>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default Experience;